define([
	"dojo/_base/declare",
	"SiteAdmin/BusinessObject",
	"SiteAdmin/Locale",
	"SiteAdmin/Locale/Renderer"
], function(declare,BusinessObject,Locale,Renderer) {

	var	VALIDATION_PREFIX = "Validation";

	return declare(Renderer, {
		_getLocaleKeys: function(/*Context*/ctx) {
			// summary: return key to store in type action section
			return [BusinessObject.getRootType(ctx.getParent()), Locale.TYPE_ACTION, VALIDATION_PREFIX + ctx.getNode().$Name];
		},

		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: return display name of validation rule
			var	keys = this._getLocaleKeys(ctx);
			return Locale.getTypeAction(keys[0], keys[2]);
		}
	});
});